const ANDROID = 'AndroidOS';
const iOS = 'iOS';
const WINDOWS_PHONE = 'WindowsPhoneOS';

export default Object.freeze({
  [ANDROID]: 'https://play.google.com/store/apps/details?id=com.hulu.plus',
  [iOS]: 'https://itunes.apple.com/us/app/hulu-plus/id376510438?mt=8',
  [WINDOWS_PHONE]: 'https://www.microsoft.com/en-us/store/p/hulu/9wzdncrfj3l1',
});
